/* =============================================================================
   NOOKS HEADER — behaviour (PRODUCTION)
   1. Scroll: header shrinks once scrollY > shrinkAt; moon rotates scrollY × speed deg
   2. Panels: menu / search / cart are mutually exclusive; Escape and scrim close
   3. Menu: Skin Concerns sub-list; closing the drawer resets to main
   Cart + predictive search are owned entirely by nooks-header.shopify.js.
   Every hook is null-guarded so any menu/config renders without throwing.
   ============================================================================= */
(function () {
  const H = document.getElementById('nk-header');
  if (!H) return;
  const speed = parseFloat(H.dataset.rotationSpeed || '0.2');
  const shrinkAt = parseFloat(H.dataset.shrinkAt || '40');
  const moons = H.querySelectorAll('.nk-moon');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. scroll ---- */
  let raf = 0;
  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      const y = window.scrollY || 0;
      H.classList.toggle('is-shrunk', y > shrinkAt);
      if (!reduce) moons.forEach(m => { m.style.transform = 'rotate(' + (y * speed).toFixed(1) + 'deg)'; });
    });
  }
  addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* ---- 2. panels ---- */
  const panels = { menu: H.querySelector('#nk-menu'), search: H.querySelector('#nk-search'), cart: H.querySelector('#nk-cart') };
  const scrim = H.querySelector('[data-nk-scrim]');
  const openers = H.querySelectorAll('[data-nk-open]');
  let current = null, lastFocus = null;

  function setOpen(name) {
    Object.entries(panels).forEach(([k, p]) => {
      if (!p) return;
      const on = k === name;
      p.classList.toggle('is-open', on);
      p.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
    openers.forEach(b => b.setAttribute('aria-expanded', b.dataset.nkOpen === name ? 'true' : 'false'));
    if (scrim) scrim.classList.toggle('is-open', !!name);
    document.documentElement.style.overflow = name ? 'hidden' : '';
    if (name && panels[name]) {
      lastFocus = document.activeElement;
      const p = panels[name];
      const f = name === 'search' ? p.querySelector('[data-nk-search-input]') : p.querySelector('[data-nk-close]');
      setTimeout(() => f && f.focus(), 20);
    } else {
      showSub(null);
      lastFocus && lastFocus.focus && lastFocus.focus();
    }
    current = name;
  }
  openers.forEach(b => b.addEventListener('click', () => setOpen(current === b.dataset.nkOpen ? null : b.dataset.nkOpen)));
  // Close via delegation on the header so the X / "Continue shopping" always work,
  // even if a panel's inner HTML is re-rendered by the cart logic.
  H.addEventListener('click', function (e) {
    if (e.target.closest('[data-nk-close]')) { e.preventDefault(); setOpen(null); }
  });
  if (scrim) scrim.addEventListener('click', () => setOpen(null));
  addEventListener('keydown', e => { if (e.key === 'Escape' && current) setOpen(null); });

  /* ---- 3. sub-menus (N nested lists, each keyed by parent index) ---- */
  const main = H.querySelector('[data-nk-menu-main]');
  const subPanels = H.querySelectorAll('[data-nk-menu-sub]');
  const subOpeners = H.querySelectorAll('[data-nk-sub-open]');
  const subClosers = H.querySelectorAll('[data-nk-sub-close]');
  let openSubKey = null;

  function panelFor(key) { return H.querySelector('[data-nk-menu-sub="' + key + '"]'); }
  function openerFor(key) { return H.querySelector('[data-nk-sub-open="' + key + '"]'); }

  function showSub(key) {
    // key === null => back to main; otherwise open the panel with that key
    if (!main) return;
    const target = key == null ? null : panelFor(key);
    if (key != null && !target) return; // no such panel
    main.hidden = key != null;
    subPanels.forEach(p => { p.hidden = (p.getAttribute('data-nk-menu-sub') !== String(key)); });
    subOpeners.forEach(b => b.setAttribute('aria-expanded', b.getAttribute('data-nk-sub-open') === String(key) ? 'true' : 'false'));
    openSubKey = key;
    if (target) {
      const back = target.querySelector('[data-nk-sub-close]');
      setTimeout(() => back && back.focus(), 20);
    }
  }
  subOpeners.forEach(b => b.addEventListener('click', () => showSub(b.getAttribute('data-nk-sub-open'))));
  subClosers.forEach(b => b.addEventListener('click', () => {
    const key = b.getAttribute('data-nk-sub-close');
    showSub(null);
    const opener = openerFor(key);
    opener && opener.focus();
  }));
})();
